import { colors } from "libs/purple-ui/shared/theme.colors";
import { font } from "libs/purple-ui/shared/theme.fonts";
import { borderRadius } from "libs/purple-ui/shared/theme.borderRadius";

export const defaultTheme = {
  colors,
  font,
  borderRadius,
};
